import React from 'react';
import { t } from '../../../../shared/components/l10n/l10n';
import moneyflowLogo from './moneyflow-logo.svg';

export default function ModalFooter() {
    return (
        <>
            <hr className="-mx-6" />
            <div className="flex justify-between">
                <div>
                    {t`MONEYFLOW_ONBOARDING_FOOTER_PROVIDER`} <img className="h-4 inline" src={moneyflowLogo} />.
                </div>
                <div>
                    {t`MONEYFLOW_ONBOARDING_FOOTER_APPROVER`} <b>{t`MONEYFLOW_ONBOARDING_FOOTER_APPROVER_NAME`}</b>.
                </div>
            </div>
        </>
    );
}
